import type * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
import type {
  ComponentPropsWithoutRef,
  ComponentRef,
  HTMLAttributes,
  ReactNode,
} from "react";

import type { TIconKey } from "@/ui/components/primitives/Icon";
import type { DefinedDefaults, TWithDataComponent } from "@/ui/lib";

/*-------------------------------------
|  Constants
|-------------------------------------*/

export const COLLAPSIBLE_TRIGGER_ICON: TIconKey = "chevronUpDown";

export const COLLAPSABLE_TRIGGER_VARIANT_CLASS_MAP: Record<TCollapablevariant, string> = {
  primary: "",
  secondary: "py-2 bg-component-collapsable-trigger-variant-secondary border border-solid border-component-collapsable-trigger-variant-secondary",
};

export const COLLAPSABLE_CONTENT_VARIANT_CLASS_MAP: Record<TCollapablevariant, string> = {
  primary: "",
  secondary: "border border-solid border-component-collapsable-content-variant-secondary border-t-0",
};

/*-------------------------------------
|  Types
|-------------------------------------*/

export type TCollapablevariant = "primary" | "secondary";
export type TCollapsibleRootProps = ComponentPropsWithoutRef<typeof CollapsiblePrimitive.Root>;
export type TCollapsibleTriggerElement = ComponentRef<typeof CollapsiblePrimitive.Trigger>;
export type TCollapsibleTriggerProps = ComponentPropsWithoutRef<typeof CollapsiblePrimitive.Trigger> & {
  triggerIcon?: TIconKey;
};
export type TCollapsibleContentElement = ComponentRef<typeof CollapsiblePrimitive.Content>;
export type TCollapsibleContentProps = ComponentPropsWithoutRef<typeof CollapsiblePrimitive.Content>;

export type TCollapsibleProps = TCollapsibleRootProps & {
  variant?: TCollapablevariant;
  contentClassName?: string;
  icon?: TIconKey;
  triggerIcon?: TIconKey;
  title: ReactNode;
  triggerClassName?: string;
} & TWithDataComponent & Pick<HTMLAttributes<HTMLElement>, "className" | "children">;

type TCollapsibleDefaultProps = DefinedDefaults<
  TCollapsibleProps,
  "data-component" |
  "triggerIcon" |
  "variant"
>;

/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const COLLAPSIBLE_DEFAULTS = {
  "data-component": "Collapsible",
  triggerIcon: COLLAPSIBLE_TRIGGER_ICON,
  variant: "primary",
} satisfies TCollapsibleDefaultProps;
